import useTheme from 'branding/theme';
import React, { useCallback, useRef, useState } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import useComponentMargin from '../../hooks/useComponentMargin';
import useFormError from '../../hooks/useFormError';
import Label from '../../typography/Label';
import Button from '../Button';
import InputError from '../InputError';
const ImageUpload = ({ name, displayName, required = false, disabled = false, size = 'large', showErrMessage = true, buttonText = 'Upload image', removeButtonText = 'Remove', previewSize = 12, centerLabel = false, wrapperStyles, styles }) => {
    const inputRef = useRef(null);
    const { formState: { errors }, control } = useFormContext();
    const { field } = useController({ name, control });
    const [preview, setPreview] = useState(field.value || null);
    const [errorId, errorMessage] = useFormError(errors, name);
    const { sizing, colors } = useTheme();
    const marginStyles = useComponentMargin({
        marginVertical: 'small',
        ...((!showErrMessage || !errorMessage) && { marginBottom: 'regular' })
    });
    const mergedWrapperStyles = {
        width: sizing.widths.input[size],
        ...marginStyles,
        ...wrapperStyles
    };
    const previewStyles = {
        width: `${previewSize}rem`,
        height: `${previewSize}rem`,
        objectFit: 'cover',
        borderRadius: '50%',
        border: `0.2rem solid ${colors.neutrals.borderBeta}`
    };
    const previewWrapperStyles = {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'flex-start'
    };
    const triggerFileInput = useCallback(() => {
        var _a;
        (_a = inputRef.current) === null || _a === void 0 ? void 0 : _a.click();
    }, []);
    const handleFileChange = useCallback((e) => {
        var _a;
        const file = (_a = e.target.files) === null || _a === void 0 ? void 0 : _a[0];
        if (!file)
            return;
        const reader = new FileReader();
        reader.onloadend = () => {
            const result = reader.result;
            setPreview(result);
            field.onChange(result);
        };
        reader.readAsDataURL(file);
    }, [field]);
    const handleRemove = useCallback(() => {
        setPreview(null);
        field.onChange('');
        if (inputRef.current) {
            inputRef.current.value = '';
        }
    }, [field]);
    return (React.createElement("div", { style: mergedWrapperStyles },
        displayName && (React.createElement(Label, { htmlFor: name, required: required, disabled: disabled, centered: !!centerLabel }, displayName)),
        React.createElement("input", { ref: inputRef, type: "file", accept: "image/*", onChange: handleFileChange, disabled: disabled, style: { display: 'none' } }),
        preview ? (React.createElement("div", { style: previewWrapperStyles },
            React.createElement("img", { src: preview, alt: displayName || name, style: previewStyles }),
            React.createElement(Button, { variant: "secondary", size: "small", onClick: handleRemove, disabled: disabled, styles: { marginTop: '0.8rem', ...styles } }, removeButtonText))) : (React.createElement(Button, { variant: "outline", onClick: triggerFileInput, type: "button", disabled: disabled, styles: styles }, buttonText)),
        showErrMessage && errorMessage && (React.createElement(InputError, { id: errorId }, errorMessage))));
};
export default ImageUpload;
//# sourceMappingURL=index.js.map